const Profile = () => (
  <>
    <p className="console-panel-desc">管理个人账户信息与安全设置。</p>
    <div className="console-card" style={{ maxWidth: '32rem' }}>
      <div className="console-card-body">
        <div className="console-form-row">
          <div>
            <label className="console-label">用户名</label>
            <input className="console-input" defaultValue="lvchunlc" readOnly />
          </div>
          <div>
            <label className="console-label">邮箱</label>
            <input className="console-input" type="email" placeholder="you@example.com" />
          </div>
        </div>
        <div className="console-form-row two-col">
          <div>
            <label className="console-label">名字</label>
            <input className="console-input" placeholder="名" />
          </div>
          <div>
            <label className="console-label">姓氏</label>
            <input className="console-input" placeholder="姓" />
          </div>
        </div>
        <button type="button" className="console-btn" style={{ marginTop: '0.5rem' }}>
          保存修改
        </button>
      </div>
    </div>
  </>
);

export default Profile;
